module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./home-updates.md");


//////////////////
// WEBPACK FOOTER
// ./src/components/routes/home-updates.md
// module id = 343
// module chunks = 5 47